import { globalCountryId } from '$/components/core/Localization/hooks/useLocalizationStore';
import { type I18nCache } from '$/components/core/Localization/localizationPersistence';
import { type Country } from '$/services/usecases/internationalization/mapper/countries';

export const getMainLanguage = (country: Country | undefined) =>
  country?.mainLanguage ?? country?.languages[0] ?? 'en';

export const resolveSupportedLocalization = (
  countries: Country[],
  requested: I18nCache,
): I18nCache => {
  const country =
    countries.find(({ id }) => id === requested.country) ??
    countries.find(({ id }) => id === globalCountryId);

  return {
    country: country?.id ?? globalCountryId,
    language: country?.languages.includes(requested.language)
      ? requested.language
      : getMainLanguage(country),
  };
};
